module.exports = __webpack_public_path__ + "img/weddings_03_V.2bcee02b.jpg";